/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAgentGroupDetails } from '../../models/api-response-agent-group-details';

export interface GetAgentGroupByRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
}

export function getAgentGroupByRef(http: HttpClient, rootUrl: string, params: GetAgentGroupByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroupDetails>> {
  const rb = new RequestBuilder(rootUrl, getAgentGroupByRef.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAgentGroupDetails>;
    })
  );
}

getAgentGroupByRef.PATH = '/v1/api/ui/agent-group/{ref}';
